module.exports = {
	"all_scored": 5199
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersAllScored.json
// module id = 921
// module chunks = 0